module.exports = __webpack_public_path__ + "17411c44f860d8bf613d5c4b0bff3d7d.png";